<span class="value">
    <app-animated-value [value]="value() | number" />
    @if (unit()) {
        <span>{{ unit() }}</span>
    }
</span>
<span class="label">{{ label() }}</span>
<ng-content />
